import "core-js/modules/es6.array.some";

var t = ["width", "height", "top", "right", "bottom", "left"],
    n = function n(_n, e) {
  return void 0 === _n && (_n = {}), void 0 === e && (e = {}), t.some(function (t) {
    return _n[t] !== e[t];
  });
};

export default function (t, e) {
  var o,
      i,
      r = function r() {
    var u = t.getBoundingClientRect();
    n(u, o) && e(o = u), i = requestAnimationFrame(r);
  };

  return {
    observe: r,
    unobserve: function unobserve() {
      cancelAnimationFrame(i);
    }
  };
}
;